module.exports = __webpack_public_path__ + "media/images/lb/753-2d76355cfe17549e3a9bcfd2348990ac.svg";